module.exports = __webpack_public_path__ + "static/media/baby-carriage.956eb5db.svg";